import React, { ReactNode, memo, useEffect } from "react";
import { isEmpty, isNil } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import Layout from "../../Layout";
import { ApplicationState } from "../../../store";
import { Data } from "../../../store/merchant/types";
import { getById } from "../../../store/merchant/queries";
import { fetchRequest as fetchMerchant } from "../../../store/merchant/actions";
import MerchantEditForm from "../merchantEditForm/MerchantEditForm";
import useSession from "../../../effects/useSession";
import pageStyles from "../../pageStyles";
import PageHeading from "../../../common/pageHeading/PageHeading";
import { fetchRequest as fetchProcessor } from "../../../store/processor/actions";
import { fetchRequest as fetchCardTypes } from "../../../store/cardType/actions";
import { fetchRequest as fetchMcc } from "../../../store/mcc/actions";

const CREATE = "CREATE";
const UPDATE = "UPDATE";

function MerchantEdit(): React.ReactElement {
  const dispatch = useDispatch();
  const classes = pageStyles();

  const { id } = useParams<{ id: string }>();
  const mode = id ? UPDATE : CREATE;

  const merchantState = useSelector(
    (state: ApplicationState) => state.merchant
  );
  const mcc = useSelector((state: ApplicationState) => state.mcc.data) ?? [];

  const session = useSession();
  useEffect(() => {
    !isNil(id) && dispatch(fetchMerchant(id));
    dispatch(fetchProcessor(null));
    dispatch(fetchCardTypes(null));
    if (isEmpty(mcc)) {
      dispatch(fetchMcc());
    }
  }, []);

  const merchant = useSelector(id ? getById(id) : () => null) as Data;
  const headingText = () => {
    return mode === CREATE ? "New Merchant" : "Edit Merchant";
  };
  const isCreate = Boolean(mode === CREATE);
  return (
    <Layout sessionData={session}>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            <Grid xs={12} md={12} lg={12}>
              <Paper>
                <PageHeading heading={headingText()} />
              </Paper>
            </Grid>
            <Grid xs={12}>
              {mode === "UPDATE" && merchant && merchant.createdAt && (
                <MerchantEditForm isCreate={isCreate} merchant={merchant} />
              )}
              {mode === CREATE && (
                <MerchantEditForm isCreate={isCreate} merchant={merchant} />
              )}
            </Grid>
          </Grid>
        </Container>
      </main>
    </Layout>
  );
}

export default memo(MerchantEdit);
